// Legge l'origin del backend a runtime (non al momento dell'import del modulo)
// così window.VEDA_API_URL è già stato impostato da index.js.
function backend() {
  return window.VEDA_API_URL || process.env.REACT_APP_BACKEND_URL || '';
}

async function getCsrfToken() {
  await fetch(`${backend()}/sanctum/csrf-cookie`, { method: 'GET', credentials: 'include' });
  return document.cookie
    .split('; ')
    .find((c) => c.startsWith('XSRF-TOKEN='))
    ?.split('=')[1] ?? '';
}

function authHeaders(csrfToken) {
  return {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-XSRF-TOKEN': decodeURIComponent(csrfToken),
  };
}

// ─── URL redirect per SPID / CIE ─────────────────────────────────────────────

export function getSpidLoginUrl() {
  return `${backend()}/api/v1/operatore/auth/spid/login`;
}

export function getCieLoginUrl() {
  return `${backend()}/api/v1/operatore/auth/cie/login`;
}

// ─── Login email + password ───────────────────────────────────────────────────

export async function loginEmail(email, password) {
  const csrf = await getCsrfToken();
  const res  = await fetch(`${backend()}/api/v1/operatore/auth/login`, {
    method: 'POST',
    credentials: 'include',
    headers: authHeaders(csrf),
    body: JSON.stringify({ email, password }),
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    return { errore: body?.message ?? body?.errors?.email?.[0] ?? 'Credenziali non valide.' };
  }

  return res.json();
}

// ─── Verifica TOTP ────────────────────────────────────────────────────────────

export async function verificaMfa(codiceMfa) {
  const csrf = await getCsrfToken();
  const res  = await fetch(`${backend()}/api/v1/operatore/auth/mfa`, {
    method: 'POST',
    credentials: 'include',
    headers: authHeaders(csrf),
    body: JSON.stringify({ codice_mfa: codiceMfa }),
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    return { errore: body?.message ?? body?.errors?.codice_mfa?.[0] ?? 'Codice non valido.' };
  }

  return res.json();
}

// ─── Registrazione ────────────────────────────────────────────────────────────

export async function registraOperatore(dati) {
  const csrf = await getCsrfToken();
  const res  = await fetch(`${backend()}/api/v1/operatore/auth/registra`, {
    method: 'POST',
    credentials: 'include',
    headers: authHeaders(csrf),
    body: JSON.stringify(dati),
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    return { errore: body?.message ?? 'Errore durante la registrazione.', errors: body?.errors };
  }

  return res.json();
}

// ─── Me (profilo operatore autenticato) ──────────────────────────────────────

export async function getMe(token) {
  const res = await fetch(`${backend()}/api/v1/operatore/me`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) throw new Error('Non autorizzato');

  return res.json();
}
